import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [ 'content' ]  

  connect () {
      document.body.classList.remove('js-body-noscroll')
  }

  disconnect () {    
    this.contentTarget.classList.add('js-menu-hiden')
    document.body.classList.toggle('js-body-noscroll')
  }

  clickHandlerOpen () {
    console.log('Menu open')
    this.contentTarget.classList.remove('js-menu-hiden')
    document.body.classList.toggle('js-body-noscroll')
  }

  clickHandlerClose () {
    console.log('Menu close')
    this.contentTarget.classList.add('js-menu-hiden')
    document.body.classList.toggle('js-body-noscroll')
  }
}
